export const fmtLongDate = (iso) => {
    if (!iso) return "—";
    const d = new Date(iso);
    const weekday = d.toLocaleDateString("es-ES", { weekday: "long" });
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${weekday} ${day}-${month}-${year}`;
};

export const formatDate = (dateString) => {
    if (!dateString) return "—";
    const date = new Date(dateString);
    return date.toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "2-digit" });
};

export const isImage = (url = "") => /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(url);
export const isPdf = (url = "") => /\.pdf$/i.test(url);
export const isExcel = (url = "") => /\.(xls|xlsx|csv)$/i.test(url);

export const ordenarPlatosDeMenu = (menu) => {
    const platos = Array.isArray(menu?.platos) ? [...menu.platos] : [];

    if (Array.isArray(menu?.platoIds) && menu.platoIds.length && platos.length) {
        const pos = new Map(menu.platoIds.map((id, i) => [Number(id), i]));
        platos.sort((a, b) => {
            const ia = pos.get(Number(a.id));
            const ib = pos.get(Number(b.id));
            if (ia == null && ib == null) return 0;
            if (ia == null) return 1;
            if (ib == null) return -1;
            return ia - ib;
        });
        return platos;
    }

    if (platos.length && platos.every((p) => p?.orden != null)) {
        platos.sort((a, b) => a.orden - b.orden);
    }

    return platos;
};
